import React, { useCallback } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useTheme, makeStyles } from "@mui/styles";
import { Dialog, Button } from "@shared/components";
import { ReactComponent as ConfirmCheck } from "@assets/svg/confirm_check.svg";
import { useAppDispatch, useAppSelector, useMobileLayout } from "@app/hooks";
import {
  closeSuccessDialog,
  resetRequestContactUpdateState,
  openRequestContactUpdateDialog,
} from "@requestContactUpdate/store/ducks";
import { requestContactUpdateSelector } from "@requestContactUpdate/store/selectors";

const useStyles = makeStyles(() => ({
  largeIcon: {
    width: 50,
    height: 50,
  },
}));

const RequestContactUpdateSuccessDialog = () => {
  const { successDialogOpen } = useAppSelector(requestContactUpdateSelector);
  const dispatch = useAppDispatch();
  const isMobile = useMobileLayout();
  const theme = useTheme();
  const classes = useStyles();

  const handleClose = useCallback(() => {
    dispatch(closeSuccessDialog());
    dispatch(resetRequestContactUpdateState());
  }, [dispatch]);

  const handleSendAnotherRequest = useCallback(() => {
    dispatch(closeSuccessDialog());
    dispatch(resetRequestContactUpdateState());
    dispatch(openRequestContactUpdateDialog());
  }, [dispatch]);

  return (
    <Dialog
      onClose={handleClose}
      open={successDialogOpen}
      title="REQUEST CONTACT UPDATE"
      maxWidth="sm"
      fullWidth
      closeOnBackdropClick
      actions={
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            gap: theme.spacing(4),
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
              gap: theme.spacing(3),
            },
          }}
        >
          <Button
            fullWidth={isMobile}
            size={isMobile ? "small" : "medium"}
            onClick={handleClose}
            shape="rounded"
            variant="outlined"
          >
            Close
          </Button>
          <Button
            fullWidth={isMobile}
            size={isMobile ? "small" : "medium"}
            onClick={handleSendAnotherRequest}
            shape="rounded"
          >
            Submit Another Request
          </Button>
        </Box>
      }
    >
      <Grid container spacing={isMobile ? 7.5 : 10}>
        <Grid item xs={12}>
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={5}>
            <ConfirmCheck className={classes.largeIcon} />
            <Typography variant="body2" align="center" fontSize={16} color="primary.main" mt={3}>
              Your request has been successfully submitted and will be reviewed.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default RequestContactUpdateSuccessDialog;
